import React, { useEffect, useState } from 'react';
import { Stack } from '@chakra-ui/layout';
import { Skeleton } from '@chakra-ui/skeleton';
import classes from './styles.module.scss';
import SDCard from '../../../../components/UI/SKCard';
import SourceTypeToSVG from '../../../../components/SourceTypeToSVG';
import Icon from '../../../../assets/coin.png';
import { EARNING_TYPE_MAP } from '../../utils';
import { format } from 'date-fns';
import InfiniteScroll from 'react-infinite-scroll-component';
import useService from '../../../../hooks/useService';
import { WalletService } from '../../../../service/WalletService';
import { StorageService } from '../../../../service/Storage';
import { Box, Image, Text } from '@chakra-ui/react';
import Nodata from '../../../../assets/nodata.png';
import SKCurrency from 'components/UI/SKCurrency';
import { currencyValue } from 'utils';

export default function EarningHistory(props) {
  const [page, setPage] = useState(1);
  const earningCtrl = useService(
    WalletService.getEarningHistory,
    [],
    (newData, oldData) => {
      if (!newData && !oldData) return null;
      newData = newData || [];
      oldData = oldData || [];
      return [...oldData, ...newData];
    }
  );

  useEffect(() => {
    if (!StorageService.getAccessToken() || !StorageService.getWId()) return;
    earningCtrl.call(page, StorageService.getWId());
  }, [page]);

  return (
    <div className={classes.EarningHistory}>
      {earningCtrl.isLoading && !earningCtrl.data ? (
        <Stack>
          <Skeleton height="20px" />
          <Skeleton height="20px" />
          <Skeleton height="20px" />
        </Stack>
      ) : !earningCtrl.data ? (
        <Box
          className={classes.empty}
          fontWeight={'semibold'}
          fontSize={'24px'}
        >
          {' '}
          <Box
            display={'flex'}
            flexDirection="column"
            gap={2}
            alignItems="center"
            pt={6}
          >
            <Image width="150px" src={Nodata} alt="No Data" />
            <Box color={'#111111'}>No Transaction History</Box>
            <Box
              color={'#777'}
              fontSize="14px"
              fontWeight={400}
              textAlign="center"
            >
              You haven’t earned any Chillars yet. Please do more offers and
              earn.
            </Box>
          </Box>
        </Box>
      ) : (
        <div className={classes.list} id="earningHistoryId">
          <InfiniteScroll
            dataLength={earningCtrl?.data?.length || 0}
            next={() => {
              setPage(v => v + 1);
            }}
            hasMore={true}
            loader={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  padding: '1rem',
                }}
              >
                <Stack>
                  <Skeleton height="20px" />
                  <Skeleton height="20px" />
                </Stack>
              </div>
            }
            scrollableTarget="earningHistoryId"
            className={classes.scrollView}
          >
            {earningCtrl.data.map((d, i) => (
              <EarningRow data={d} key={i} />
            ))}
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
}

function EarningRow({ data }) {
  return (
    <SDCard className={classes.EarningRow}>
      <div className={classes.hh}>
        <SourceTypeToSVG data={data} />
      </div>
      <div className={classes.content}>
        <div className={classes.title}>
          {/* {EARNING_TYPE_MAP[data.sourceEntityType] || data.sourceEntityType} */}
          {data.title}
        </div>
        <div className={classes.subtitle}>{format(data.createdAt, 'PP')}</div>
      </div>
      <div className={classes.amount}>
        {data.transaction_type === 'CREDIT' && <Text color="red.500">-</Text>}
        {data.transaction_type === 'DEBIT' && <Text color="green.500">+</Text>}
        <SKCurrency size={'15px'} />
        {currencyValue(data.valueInSikka)}
      </div>
    </SDCard>
  );
}
